const items = Object.freeze({
  Denied: 1,
  Adjustment: 2,
  Absence: 3,
  SifdeRequest: 4,
  Transfer: 5,
  Facilitate: 6,
  MissingAppointmentsWithoutExcuses: 8,
  BookSeize:9
});
export default items;
